import { useEffect, useState, useCallback } from "react";
import { API } from "@/lib/api";

export const isPro = () => localStorage.getItem("jm_pro") === "true";
export const setPro = (v) => localStorage.setItem("jm_pro", v ? "true" : "false");
export const getProEmail = () => localStorage.getItem("jm_pro_email") || "";
export const setProEmail = (e) => e ? localStorage.setItem("jm_pro_email", e) : localStorage.removeItem("jm_pro_email");

const todayKey = (slug) => `jm_tool_${slug}_${new Date().toISOString().slice(0, 10)}`;

export function useTool(slug, freeLimit = 3) {
  const [count, setCount] = useState(0);
  const [pro, setProState] = useState(isPro());

  useEffect(() => {
    setCount(parseInt(localStorage.getItem(todayKey(slug)) || "0", 10));
    setProState(isPro());
  }, [slug]);

  const canUse = pro || count < freeLimit;

  const inc = useCallback(() => {
    if (pro) return true;
    const c = parseInt(localStorage.getItem(todayKey(slug)) || "0", 10) + 1;
    localStorage.setItem(todayKey(slug), String(c));
    setCount(c);
    return true;
  }, [slug, pro]);

  return { count, limit: freeLimit, canUse, inc, pro };
}

export async function startProCheckout(email) {
  const res = await fetch(`${API}/tools/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ origin_url: window.location.origin, email: email || "" }),
  });
  const data = await res.json();
  if (data.checkout_url) window.location.href = data.checkout_url;
}

export async function restorePro(email) {
  const res = await fetch(`${API}/tools/pro/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (data.pro) {
    setPro(true);
    setProEmail(email);
  }
  return data;
}
